import { render, staticRenderFns } from "./Promoter.view.vue?vue&type=template&id=96576eda&scoped=true"
import script from "./Promoter.view.vue?vue&type=script&lang=ts"
export * from "./Promoter.view.vue?vue&type=script&lang=ts"
import style0 from "./Promoter.view.vue?vue&type=style&index=0&id=96576eda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96576eda",
  null
  
)

export default component.exports